import { useSelector } from 'react-redux';
import { ReduxState } from '../store';
import { useMemo } from 'react';

const useCategoryId = (): number => {
  const selectedCategorySlug = useSelector(
    (state: ReduxState) => state.categoryTreeReducer.currentlySelectedCategorySlug,
  );

  return useMemo(
    () => parseInt(selectedCategorySlug.split('-').pop() ?? '1'),
    [selectedCategorySlug],
  );
};

export default useCategoryId;
